module.exports = __webpack_public_path__ + "img/88.96fdbd31.png";